import { useQuery } from "@tanstack/react-query";
import addressApi from "api/landlord/address";
import { useMemo } from "react";

export const useGetInviteTemplateAndUnit = ({
  applicationId,
  propertyId,
  unitId
}: {
  applicationId?: number;
  propertyId?: number;
  unitId?: number;
}) => {
  const propertyMeta = useQuery({
    queryKey: ["properties", propertyId],
    queryFn: () => addressApi.getProperty(String(propertyId) || ""),
    enabled: Boolean(propertyId && !applicationId)
  });

  const applicationMeta = useQuery({
    queryKey: ["APPLICATION", applicationId],
    queryFn: () => addressApi.getApplicationById(String(applicationId) || ""),
    enabled: Boolean(applicationId)
  });

  const template = useMemo(() => {
    return (
      (!!applicationId ? applicationMeta : propertyMeta).data
        ?.verification_template?.settings || {}
    );
  }, [propertyMeta.data, applicationMeta.data, applicationId]);

  const unit = useMemo(() => {
    if (applicationId) return applicationMeta.data?.unit;
    if (propertyId)
      return propertyMeta.data?.units?.find((unit) => unit.id === unitId);
  }, [propertyMeta.data, applicationMeta.data, applicationId]);

  return { template, unit };
};
